import { render, staticRenderFns } from "./CommentAnswerKidHistory.vue?vue&type=template&id=6be04c2f&scoped=true"
import script from "./CommentAnswerKidHistory.vue?vue&type=script&lang=js"
export * from "./CommentAnswerKidHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be04c2f",
  null
  
)

export default component.exports